var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 16.77,
    height: 16.77,
    rx: 8.385,
    transform: "rotate(-180 17 17)",
    fill: "#041F3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1316 9.04521C13.1316 8.9722 13.1005 8.90248 13.0489 8.84999L10.2555 6.11605C10.1452 6.00805 9.96655 6.00833 9.85649 6.11605C9.74616 6.22378 9.74616 6.39877 9.85649 6.5065L12.1685 8.76905L4.38375 8.76905C4.22798 8.76905 4.10156 8.89264 4.10156 9.04521C4.10156 9.19778 4.22798 9.32136 4.38375 9.32136L12.1682 9.32136L9.85649 11.5839C9.74616 11.6916 9.74644 11.8666 9.85649 11.9744C9.96683 12.0821 10.1455 12.0821 10.2555 11.9744L13.0489 9.24043C13.1017 9.18875 13.1307 9.11766 13.1316 9.04521Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.e94df672e94799ba019136be606f7882.svg";
export { ForwardRef as ReactComponent };